<template>
    <div class="authorCenter" :style="ispopshow?'height:100vh;overflow:hidden':''" >
        <Header></Header>
        <div class="authorBox flexible authorBox-big">
            <sidebar></sidebar>
            <div class="writewrap flex">
                <writeList></writeList>
            </div>
        </div>
        <!-- <Login @changeLogin="changeLogin"></Login> -->
    </div>
    
</template>

<script>
    import {
        hideLoading,
        showLoading
    } from "@/utils/load";
    import {
        getToken
    } from "../../utils/storage";
    export default {
        data() {
            return {
                token:getToken() || null,
                uploadurl: "",
                /*分页*/
                totalPage: 0,
                busy: false,
                pageNo: 1,
                /*未读消息*/
                //   noticeNum: 0,
                ispopshow: false,
            };
        },
        created() {
        },
        mounted() {
            // window.addEventListener('scroll', this.getbottom); // 滚动到底部，再加载的处理事件
            // this.getnoticecount()
        },
        methods: {
            // 获取作者写书列表
            async getwriteList(val) {
                // console.log(val)
                showLoading()
                let res = await authorBookListApi({
                    pageSize: 10,
                    pageNo: this.pageNo
                });
                if (res.success) {
                    hideLoading()
                    if (val == 1) {
                        this.booklist = []
                    }
                    if (res.data && res.data.length == 0) {
                        this.booklist = this.booklist
                    } else {
                        this.booklist = this.booklist.concat(res.data.items);
                    }

                    this.totalPage = Number(res.data.totalPage);
                    this.busy = res.data.hasNextPage
                    this.pageNo = Number(res.data.pageNum)
                }
            },
            // // 获取未读消息总数
            // async getnoticecount () {
            //   let res = await noticecount({sort: 1});
            //   if (res.success) {
            //     this.noticeNum = res.data
            //   }
            // },
            // goBookSet() {
            //   this.$router.push('/author/create/0');
            // },
            getbottom() {
                let scrollTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                let clientHeight =
                    document.documentElement.clientHeight || document.body.clientHeight;
                let scrollHeight =
                    document.documentElement.scrollHeight || document.body.scrollHeight;
                let numHeight = scrollTop + clientHeight;
                if (scrollHeight > clientHeight && numHeight > scrollHeight - 100) {
                    if (this.busy) {
                        this.busy = false;
                        this.pageNo++;
                        this.getwriteList()
                    }
                }
            },
            changePop(data) {
                this.ispopshow = data
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
</style>